/* Ritual Organics — shared motion controller
   Watches elements with .ritual-reveal and toggles .is-in as they scroll into view.
   No dependencies. Safe to load early (defer). */

(function () {
  'use strict';

  var REVEAL_SELECTOR = '.ritual-reveal';
  var IN_CLASS = 'is-in';

  function reveal(el) {
    el.classList.add(IN_CLASS);
  }

  /* Auto-apply .ritual-reveal to any top-level .shopify-section below the viewport
     fold at script time. Opt out with class="no-reveal" or data-no-reveal on the
     section element. Skips sections that are already visible so we never flash. */
  function autoEnhanceSections() {
    var vpH = window.innerHeight;
    var sections = document.querySelectorAll('main > .shopify-section, .main-content > .shopify-section');
    sections.forEach(function (el) {
      if (el.classList.contains('no-reveal') || el.hasAttribute('data-no-reveal')) return;
      if (el.classList.contains('ritual-reveal')) return; // already tagged
      // Skip any section that contains .ritual-reveal children — handle it itself.
      if (el.querySelector('.ritual-reveal')) return;
      var rect = el.getBoundingClientRect();
      // Only auto-reveal sections that are fully below the fold at load (no flash).
      if (rect.top >= vpH * 0.9) {
        el.classList.add('ritual-reveal');
      }
    });
  }

  function init() {
    autoEnhanceSections();
    var nodes = document.querySelectorAll(REVEAL_SELECTOR);
    if (!nodes.length) return;

    // If user prefers reduced motion, reveal everything immediately (CSS also handles this).
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || typeof IntersectionObserver === 'undefined') {
      nodes.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });

    nodes.forEach(function (el) {
      // If the element is already in the viewport at load, reveal immediately (no initial flash).
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
        reveal(el);
        return;
      }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
